import _styled from "styled-components";
import { autorun } from "mobx";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import { applyTranslationIfExists } from "../../../Language/languageHelpers";
import Box, { BoxSpan } from "../../../Styled/Box";
import { StyledIcon } from "../../../Styled/Icon";
import Spacing from "../../../Styled/Spacing";
import Text from "../../../Styled/Text";
import { useViewState } from "../../Context";
import CloseButton from "../../Generic/CloseButton";
import { PrefaceBox } from "../../Generic/PrefaceBox";
import { filterViewerAndScreenSize } from "./filterViewerAndScreenSize";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const CollapsedNavigationBox = styled(Box).attrs({
  position: "absolute",
  styledWidth: "500px",
  styledMaxHeight: "320px",
  backgroundColor: "white",
  rounded: true,
  paddedRatio: 4,
  overflowY: "auto",
  scroll: true
}).withConfig({
  displayName: "CollapsedNavigation__CollapsedNavigationBox",
  componentId: "sc-uv77p8-0"
})(["z-index:1000;left:50%;top:50%;transform:translate(-50%,-50%);box-shadow:0 6px 6px 0 rgba(0,0,0,0.12),0 10px 20px 0 rgba(0,0,0,0.05);@media (max-width:", "px){width:100%;}"], props => props.theme.mobile);
const ButtonsBox = styled(Box).attrs({}).withConfig({
  displayName: "CollapsedNavigation__ButtonsBox",
  componentId: "sc-uv77p8-1"
})(["display:inline-grid;grid-template-columns:1fr 1fr 1fr 1fr;position:relative;margin-bottom:10px;gap:20px;"]);
const NavigationButton = styled(BoxSpan).attrs({
  boxShadow: true,
  centered: true,
  rounded: true
}).withConfig({
  displayName: "CollapsedNavigation__NavigationButton",
  componentId: "sc-uv77p8-2"
})(["cursor:pointer;&:hover{border:2px solid ", ";svg{opacity:0.9;}}:before{content:\"\";display:block;height:0;width:0;padding-bottom:100%;}", ""], p => p.theme.darkWithOverlay, props => props.disabled && "\n    background-color: ".concat(props.theme.grey, ";\n    color: ").concat(props.theme.grey, ";\n    opacity: 0.7;\n    svg {\n      fill: ").concat(props.theme.textLightDimmed, ";\n    }\n    &[disabled] {\n      cursor: not-allowed;\n    }\n  "));
var _StyledNavigationButton = styled(NavigationButton).withConfig({
  displayName: "CollapsedNavigation___StyledNavigationButton",
  componentId: "sc-uv77p8-3"
})(["", ""], p => p.$_css);
const CollapsedNavigationPanel = observer(props => {
  const viewState = useViewState();
  const theme = useTheme();
  const {
    t,
    i18n
  } = useTranslation();
  const items = props.items;
  return /*#__PURE__*/_jsxs(CollapsedNavigationBox, {
    column: true,
    children: [/*#__PURE__*/_jsx(CloseButton, {
      color: theme.darkWithOverlay,
      topRight: true,
      onClick: () => viewState.closeCollapsedNavigation()
    }), /*#__PURE__*/_jsx(Text, {
      extraExtraLarge: true,
      bold: true,
      textDarker: true,
      children: t("mapNavigation.additionalTools")
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 5
    }), /*#__PURE__*/_jsx(ButtonsBox, {
      children: items.map(item => /*#__PURE__*/_jsx(_StyledNavigationButton, {
        title: applyTranslationIfExists(item.name, i18n),
        onClick: () => {
          if (!item.controller.disabled) {
            viewState.closeCollapsedNavigation();
            item.controller.handleClick();
          }
        },
        disabled: item.controller.disabled,
        $_css: item.controller.active && "border: 2px solid ".concat(theme.colorPrimary, ";"),
        children: /*#__PURE__*/_jsx(StyledIcon, {
          glyph: item.controller.glyph,
          styledWidth: "22px",
          dark: true
        })
      }, item.id))
    })]
  });
});
const CollapsedNavigationDisplayName = "CollapsedNavigation";
export const CollapsedNavigation = observer(() => {
  const viewState = useViewState();
  useEffect(() => autorun(() => {
    if (viewState.showCollapsedNavigation && viewState.topElement !== CollapsedNavigationDisplayName) {
      viewState.setTopElement(CollapsedNavigationDisplayName);
    }
  }));
  let items = viewState.terria.mapNavigationModel.items.filter(item => item.controller.collapsed);
  items = items.filter(item => filterViewerAndScreenSize(item, viewState));
  if (!viewState.showCollapsedNavigation || items.length === 0) {
    viewState.closeCollapsedNavigation();
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PrefaceBox, {
      onClick: () => viewState.closeCollapsedNavigation(),
      role: "presentation",
      "aria-hidden": "true",
      pseudoBg: true
    }), /*#__PURE__*/_jsx(CollapsedNavigationPanel, {
      items: items
    })]
  });
});